import React from 'react';

const InterpolationIcon = ({ size = 40, className = '' }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(0, 0)">
      {/* Oberer Interpolationsbogen */}
      <path
        d="M0 70 C 20 40, 40 30, 60 50 C 80 70, 100 55, 100 50"
        fill="none"
        stroke="#f3f4f6"
        strokeWidth="6"
      />

      {/* Punkte auf oberer Kurve */}
      <circle cx="20" cy="47" r="6" fill="#f3f4f6" />
      <circle cx="50" cy="43" r="6" fill="#f3f4f6" />
      <circle cx="80" cy="60" r="6" fill="#f3f4f6" />
    </g>
  </svg>
);

export default InterpolationIcon;
